module.exports = __webpack_public_path__ + "img/1726038329947-screenshot-1726038310416.png.9b0cc789.webp";